import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  // Striped rows. The name is Bronson's, kept so call sites need not change.
  colored?: boolean;
  testId?: string;
  children?: ReactNode;
}

interface SectionProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  testId?: string;
}

export function Table({ colored, testId, className, children, ...otherProps }: TableProps) {
  return (
    <div className="ec-table-wrapper">
      <table {...otherProps} data-testid={testId} className={classNames('ec-table', colored && 'ec-table--striped', className)}>
        {children}
      </table>
    </div>
  );
}

Table.Thead = function Thead({ testId, ...otherProps }: SectionProps) {
  return <thead {...otherProps} data-testid={testId} />;
};

Table.Tbody = function Tbody({ testId, ...otherProps }: SectionProps) {
  return <tbody {...otherProps} data-testid={testId} />;
};

Table.Tr = function Tr(props: React.HTMLAttributes<HTMLTableRowElement>) {
  return <tr {...props} />;
};

Table.Th = function Th(props: React.ThHTMLAttributes<HTMLTableCellElement>) {
  return <th {...props} />;
};

Table.Td = function Td(props: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <td {...props} />;
};
